// extracted by mini-css-extract-plugin
export default {"item":"MenuItem-module__item__ysfGu"};